var searchMap = {
  mapContainerId: 'search_map_container',
  mapId: 'search_map_projects',
  mapStyleUrl: 'mapbox://styles/liquidmelbourne/cjanekwjz37cp2rms6lii68d6',
  mapKey: 'pk.eyJ1IjoibGlxdWlkbWVsYm91cm5lIiwiYSI6ImNqbXNnZ2o1ajAxbTYzd21yMjVpYmNtOGIifQ.iukQ2xSxuax385XC1ZJyvg',
  mapClusterMaxZoom: 14,
  mapZoom: 13,
  mapPadding: 100,
  pinSvg: '<svg class="icon" viewBox="0 0 20 20" x="0" y="0"><path d="M10 19a.78.78 0 0 0 .56-.23C10.82 18.5 17 12.18 17 8a7 7 0 0 0-7-7 7 7 0 0 0-7 7c0 4.18 6.18 10.5 6.44 10.77A.78.78 0 0 0 10 19zM7.65 8A2.35 2.35 0 1 1 10 10.39 2.35 2.35 0 0 1 7.65 8z" fill="currentColor"/></svg>',
  mapMarkers: [],
  mapInit: false,
  resetFitBounds: function(animate) {
    var _this = this;

    if ( _this.mapInit == false ) { return; }
    // var easing = !animate ? 'linear: true' : '';
    if(_this.mapMarkers.length < 2) {
        var options = {
            padding: {top: _this.mapPadding, bottom:_this.mapPadding, left: _this.mapPadding, right: _this.mapPadding},
            maxZoom: 16
          }
    } else {
        var options = {
                padding: {top: _this.mapPadding, bottom:_this.mapPadding, left: _this.mapPadding, right: _this.mapPadding},
                // maxZoom: _this.mapZoom
            }
    }


    if ( !animate ) {
      options.linear = true;
    }

    if ( !status ) {
      status = null;
    }

    _this.map.fitBounds(_this.mapBbox, options);

  },


  loadMapProjects: function(data_geojson) {
    var _this = this;

    if ( _this.mapInit == false ) { return; }

    _this.projectsLoaded = true;

    // == Add markers to map
    _this.addMarkers(data_geojson.features);
    // _this.loadMarkers(data_geojson);


    // == Reposition map
    _this.resetFitBounds(false);
    _this.map.once('moveend', fitBoundsEnd);

    function fitBoundsEnd() {
      // fade in map
      $('#' + _this.mapContainerId).removeClass('loading');

      _this.map.off('moveend', fitBoundsEnd);
    }

    _this.map.on('resize',function(){

      // recenter map (with animation)
      _this.resetFitBounds(true);

    })


    // == On card hover: highlight marker
    if ( _this.listings.length > 0 ) {

      var cards = _this.listings.find('.item .thumbnail');

      // cards.on('mouseenter', function(e) {
      cards.on('mousemove', function(e) {
        // e.stopPropagation();
        var id = $(this).parents('.item').attr('id').replace('listing-','');
        $('.marker[data-id="'+id+'"]').addClass('highlighted');
      });

      cards.on('mouseleave', function(e) {
        // e.stopPropagation();
        var id = $(this).parents('.item').attr('id').replace('listing-','');
        $('.marker[data-id="'+id+'"]').removeClass('highlighted');
      });

    }

  },

  updateMapProjects: function(data_geojson) {
    var _this = this;

    if ( _this.mapInit == false ) { return; }

    // update markers
    _this.updateMarkers(data_geojson);


    // update map position

    if ( data_geojson ) {
      _this.mapBbox = new mapboxgl.LngLatBounds();
      data_geojson.features.forEach(function(f) {
        _this.mapBbox.extend(f.geometry.coordinates);
      });
    }

    _this.resetFitBounds(false);
    _this.map.once('moveend', fitBoundsEnd);

    function fitBoundsEnd() {
      _this.map.off('moveend', fitBoundsEnd);
    }
    _this.map.on('resize',function(){
      // recenter map (with animation)
      _this.resetFitBounds(true);

    })

  },


  updateMarkers: function(projects) {
    var _this = this;

    // Do not update data if map is not init
    if ( !_this.map ) { return; }

    // if active pin: remove popup + unactive pin and listing
    // if ( _this.map.getLayer('unclustered-point-active') ) {
    //   $('.mapboxgl-popup-close-button').trigger('click');
    // }

    if ( projects ) {
      // update markers
      //_this.map.getSource('projects').setData(projects);
      _this.removeMarkers();
      _this.addMarkers(projects.features)

      // rebound map
      _this.resetFitBounds();

      // show layers if were hidden
      // _this.map.setLayoutProperty('clusters', 'visibility', 'visible');
      // _this.map.setLayoutProperty('unclustered-point', 'visibility', 'visible');
      // _this.map.setLayoutProperty('cluster-count', 'visibility', 'visible');
    } else {
      // hide layers if no data
      // _this.map.setLayoutProperty('clusters', 'visibility', 'none');
      // _this.map.setLayoutProperty('unclustered-point', 'visibility', 'none');
      // _this.map.setLayoutProperty('cluster-count', 'visibility', 'none');
    }

  },

  // features needs to be geojson data features
  addMarkers: function(features) {
    var _this = this;
    if ( _this.mapInit == false ) { return; }
    // Add markers to map
    features.forEach(function(feature) {

      var prop = feature.properties;

      // create a HTML element for each feature
      var el = document.createElement('div');
      el.className = 'marker';
      el.innerHTML = _this.pinSvg;
      el.setAttribute('data-id',prop.id);

      // make a marker for each feature and add to the map
      var marker = new mapboxgl.Marker(el)
      .setLngLat(feature.geometry.coordinates)
      .addTo(_this.map);

      // Save marker to array
      _this.mapMarkers.push(marker);

      // on click on marker
      $(el).on('click',function(){
        var $listing = $('#listing-' + prop.id);

        // Add active style to this marker
        // _this.setActiveSymbol(feature);
        $('.marker').removeClass('active');
        $(el).addClass('active');

        // Add active style to card in the side listing
        // _this.setActiveListing(prop.id);
        $('#project_list .item.active').removeClass('active');
        $('#listing-' + prop.id).addClass('active');

        // Fly to the point and center marker + popup
        _this.map.flyTo({
          center: feature.geometry.coordinates,
          offset: [0, 100] // [x,y] offset because of popup
        });

        // Close all other popups and display popup for clicked store
        _this.createPopUp(feature);


        // Scroll to listing in sidebar

        if ( $listing.length > 0 ) {
          // get listing top offset
          var listingOffset = $listing.offset().top;
          // animate to offset
          var offset = listingOffset - _this.listings.offset().top +  _this.listings.scrollTop();
          _this.listings.animate({ scrollTop: offset }, 'slow');
          // $('#project_list').animate({ scrollTop: 0 }, 'slow');
        }
      })

    });
  },

  removeMarkers: function() {
    var _this = this;
    if ( _this.mapInit == false ) { return; }

    // remove markers from the map
    for (var i = 0; i < _this.mapMarkers.length; i++ ) {
      _this.mapMarkers[i].remove();
    }

    // empty markers array
    _this.mapMarkers = [];
  },

  setActiveListing: function(id) {
    var _this = this;
    $('#project_list .item.active').removeClass('active');
    $('#listing-' + id).addClass('active');
  },

  removeActiveListing: function(id) {
    var _this = this;
    $('#listing-' + id).removeClass('active');
  },

  removeActiveMarker: function() {
    var _this = this;
    if ( _this.mapInit == false ) { return; }
    $('.marker').removeClass('active');
  },

  removePopup: function() {
    if ( this.mapInit == false ) { return; }
    var popUps = document.getElementsByClassName('mapboxgl-popup');
    // Check if there is already a popup on the map and if so, remove it
    if (popUps[0]) popUps[0].remove();
  },


  createPopUp: function(currentFeature) {
    var _this = this;
    if ( _this.mapInit == false ) { return; }
    var popUps = document.getElementsByClassName('mapboxgl-popup');
    // Check if there is already a popup on the map and if so, remove it
    if (popUps[0]) popUps[0].remove();

    var prop = currentFeature.properties;

    // var lngLat = [prop.locationLng, prop.locationLat];
    var lngLat = currentFeature.geometry.coordinates;

    var address = prop.address != '' ? '<p class="item-address mb0 text-small">'+prop.address+'</p>' : '';
    var heading = prop.location != '' ? '<h4 class="item-heading mb0"><b>'+prop.name+'</b><br>'+prop.location+'</h4>' : '<h4 class="item-heading mb0"><b>'+prop.name+'</b></h4>';

    var link = prop.link;

    var marker_image = '';
    var imgClass = 'no-img';
    var hasSlider = false;

    var image_url = prop.imgUrl ? prop.imgUrl : null;

    if ( prop.images && prop.images.length > 0 ) {
      imgClass = 'has-img';

      // Single Image
      if ( prop.images.length < 2 ) {
        marker_image = '<div class="item-image">'+
          '<a href="' + link + '" target="_blank" style="background-image: url(\''+ prop.images[0] +'\')"></a>' +
        '</div>';
      }

      // Slider
      else {
        slides = '';
        for (var i = 0; i < prop.images.length; i++) {
          // slides += '<div class="slide"><a href="'+link+'" target="_blank" class="img" style="background-image: url(\''+prop.images[i]+'\')"></a></div>';
          slides += '<div class="slide"><a href="'+link+'" target="_blank" class="img"><img data-lazy="'+prop.images[i]+'" alt="'+prop.name+'" /></a></div>';
        }

        marker_image = '<div class="item-image listing-item-slider">'+
          '<div class="slider-container"><div class="slider">' + slides + '</div></div>' +
        '</div>';

        hasSlider = true;
      }
    }

    // if (image_url) {
    //   marker_image = '<div class="item-image">'+
    //     '<a href="' + link + '" style="background-image: url(\''+ image_url +'\')"></a>' +
    //   '</div>';
    //   imgClass = 'has-img';
    // }



    var markup = [
      marker_image,
      '<div class="item-content">',
        '<a class="item-info" href="'+ link +'" target="_blank">',
            heading,
            address,
            '<span class="item-link">Find out more</span>',
        '</a>',
      '</div>',
    ].join('');

    var popup = new mapboxgl.Popup({
      closeOnClick: false,
      anchor: 'bottom',
    })
    .setLngLat(lngLat)
    .setHTML(markup)
    .addTo(_this.map);

    if ( hasSlider === true ) {
      _this.initItemSlider($('.mapboxgl-popup'));
    }

    // update close icon
    $('.mapboxgl-popup-content').addClass(imgClass);
    // var path = 'http://' + window.location.hostname;
    // $('.mapboxgl-popup-close-button').html('<img alt="close" src="'+ path +'/images/mapbox/map-close.png" />');



    popup.on('close',function(){
      _this.removeActiveListing(prop.id);
      // _this.removeActiveSymbol();
      _this.removeActiveMarker();
    });

  },


  initMap: function() {
    var _this = this;

    if ( _this.mapInit == true ) { return; }

    mapboxgl.accessToken = _this.mapKey;

    if ( _this.mapProjects ) {
      _this.mapBbox = new mapboxgl.LngLatBounds();
      _this.mapProjects.features.forEach(function(f) {
        _this.mapBbox.extend(f.geometry.coordinates);
      });
    }

    if ( $('#' + _this.mapId).length < 1 ) { return; }

    _this.map = new mapboxgl.Map({
      // container id specified in the HTML
      container: _this.mapId,
      style: _this.mapStyleUrl,
      center: [151.21, -33.868], // Sydney
      zoom: _this.mapZoom,
      attributionControl: false,
      scrollZoom: false
    });

    mapNavControl = new mapboxgl.NavigationControl();
    _this.map.addControl(mapNavControl, 'top-right');

    _this.mapPin = $('#search_map_projects').attr('data-marker');
    _this.mapPinActive = $('#search_map_projects').attr('data-marker-active');

    _this.listings = $('#project_list_container');


    _this.map.on('load',function(e) {

      _this.loadMapProjects(_this.mapProjects);

    })

    _this.mapInit = true;
  },


  destroyMap: function() {
    if ( this.mapInit == false ) { return; }
    this.map.remove();
    this.mapInit = false;
  },

  // handleMarkerClick: function(project_id, minArea_val, maxArea_val) {
  //    _this = this;

  //   // show spinner
  //   $('.listing-search-section .col-grid .spinner').addClass('animate');
  //   $('.listing-search-section .col-grid').addClass('loading');

  //   var ajaxurl = admin_ajax_url;
  //   $.ajax({
  //     type: 'POST',
  //     url: ajaxurl,
  //     data: {"action": "liquid_get_single_project", project_id: project_id, minarea: minArea_val, maxarea: maxArea_val},
  //     success: function (response) {
  //       $("#project_list").html(response);
  //       // hide spinner
  //       $('.listing-search-section .col-grid').removeClass('loading');
  //       setTimeout(function(){
  //         $('.listing-search-section .col-grid .spinner').removeClass('animate');
  //       }, 400);

  //       shortlist.checkIfProductsShortlisted();
  //       shortlist.checkIfProjectsShortlisted();
  //     }
  //   });
  // },

  handleSubmit: function(regions_val, minArea_val, maxArea_val) {
    _this = this;
    var ajaxurl = admin_ajax_url;

    // if mobile: scroll to results
    if ( Modernizr.mq("screen and (max-width:"+bp_tablet_portrait+"px)")) {
      $('body,html').stop().animate({
        'scrollTop': $('#project_list_container').offset().top
      }, 200);
    }

    if(regions_val) {
        window.history.pushState(
            regions_val,
            'Offices for Lease Sydney | ' + regions_val + ' | Cadigal',
            '/offices-for-lease/' + regions_val.toLowerCase().replace(/[^\w ]+/g,'').replace(/ +/g,'-')
        );
    } else {
        window.history.pushState(
            '',
            'Offices for Lease Sydney | Cadigal',
            '/offices-for-lease'
        );
    }

    // show spinner
    $('.listing-search-section .col-grid .spinner').addClass('animate');
    $('.listing-search-section .col-grid').addClass('loading');

    // show "reset search"
    $('#reset_projects_search').removeClass('is-hidden');

    if($("#no_project_found").length > 0) {
        $("#no_project_found").remove();
    }

    // update listing
    $.ajax({
      type: 'POST',
      url: ajaxurl,
      dataType: 'JSON',
      data: {
        "action": "liquid_search_projects",
        regions: regions_val,
        minarea: minArea_val,
        maxarea: maxArea_val
      },
      success: function (data) {

        // var markup = ['<div id="listing-0" class="item">',
        //                '<div class="thumbnail full-bg" style="background-image:url('+window.project_search_grid_static_banner+'); width:100%; height:100%; background-repeat: no-repeat; background-size: cover;">',
        //                '<a href="'+window.project_search_grid_static_banner_link+'"></a>',
        //                 '</div>',
        //                 '</div>'].join('');

        var staticBanner = ['<div class="thumbnail">',
                          '<a href="'+window.project_search_grid_static_banner_link+'" target="_blank" style="background-image:url('+window.project_search_grid_static_banner+');">',
                            '<div class="info">',
                                '<div class="info-inner" >',
                                    '<h3 class="title"><b>Find your<br>ideal space</b></h3>',
                                  '</div>',
                            '</div>',
                            '<div class="img-container" style="-webkit-font-smoothing: subpixel-antialiased!important;transform: translateZ(0) scale(1.0, 1.0)!important;-webkit-transform: translateZ(0) scale(1.0, 1.0)!important;">',
                              '<div class="img-wrapper listing-item-slider"><div class="content"><div class="inner"><p>Allow us to review your workspace requirements and send you a tailored report of options.</p><span class="btn secondary-btn">Find my Space</span></div></div></div>',
                            '</div>',
                          '</a>',
                      '</div>'].join('');

          var markup = '<div id="listing-0" class="item item-banner mobile-hidden">' + staticBanner + '</div>';

        // Projects found
        if ( data ) {

          for ( var i = 0; i < data.features.length; i++ ) {
            var p = data.features[i];
            var prop = data.features[i].properties;

            var location = prop.location ? '<p class="mb0 location">'+prop.location+'</p>' : '';

            // Image
            var image = prop.imgUrl ? '<a href="'+prop.link+'" target="_blank" class="img" style="background-image: url(\''+ prop.imgUrl +'\')"></a>' : '';
            // var image = prop.imgUrl ? '<a href="'+prop.link+'" target="_blank" class="img lazyload" data-original="'+ prop.imgUrl +'"></a>' : '';

            // Slider

            var image_url = prop.imgUrl ? prop.imgUrl : null;
            var image = '<a href="'+prop.link+'" target="_blank" class="img empty"></a>';
            if ( prop.images && prop.images.length > 0 ) {

              // Single Image
              if ( prop.images.length < 2 ) {
                image = '<a href="' + prop.link + '" target="_blank" class="img" style="background-image: url(\''+ prop.images[0] +'\')"></a>';
                // image = '<a href="' + prop.link + '" target="_blank" class="img lazyload" data-original="'+ prop.images[0] +'"></a>';
              }

              // Slider
              else {
                // image = '<a href="' + prop.link + '" class="img" style="background-image: url(\''+ prop.images[0] +'\')"></a>';
                slides = '';
                for (var j = 0; j < prop.images.length; j++) {
                  // slides += '<div class="slide"><a href="'+prop.link+'" target="_blank" class="img" style="background-image: url(\''+prop.images[j]+'\')"></a></div>';
                  slides += '<div class="slide"><a href="'+prop.link+'" target="_blank" class="img"><img data-lazy="'+prop.images[j]+'" alt="'+prop.name+'" /></a></div>';
                }

                image = '<div class="img-wrapper listing-item-slider">'+
                  '<div class="slider-container"><div class="slider">' + slides + '</div></div>' +
                '</div>';
              }
            }

            var shortlistClass = prop.shortlisted ? 'removeprojectfromshortlist active' : '';
            var shortlistTooltip = prop.shortlisted ? tooltip_shortlist_remove : tooltip_shortlist_add;

            var area = prop.area ? '<li>'+prop.area+' sqm</li>' : '';
            var outgoings = prop.outgoings ? '<li>'+prop.outgoings+'</li>' : '';

            // var details_area = area || outgoings ? '<ul class="details">'+area+outgoings+'</ul>' : '';
            var details_area = area ? '<ul class="details">'+area+'</ul>' : '';
            var details_outgoings = outgoings ? '<ul class="details">'+outgoings+'</ul>' : '';

            markup += ['<div id="listing-'+prop.id+'" class="item">',
              '<div class="thumbnail">',
                  '<div class="info">',
                      '<a class="info-inner" href="'+prop.link+'" target="_blank">',
                          '<h3 class="name">'+prop.name+'</h3>',
                          details_area,
                          // details_outgoings,
                          location,
                      '</a>',
                  '</div>',
                  prop.space_availability,
                  '<div class="img-container" style="-webkit-font-smoothing: subpixel-antialiased!important;transform: translateZ(0) scale(1.0, 1.0)!important;-webkit-transform: translateZ(0) scale(1.0, 1.0)!important;">',
                      '<span class="shortlist addprojecttoshortlist '+shortlistClass+'" data-projectid="'+prop.id+'" title="'+shortlistTooltip+'" data-toggle="tooltip" data-placement="top">',
                          // '<i class="icon-empty-star"></i>',
                          // '<i class="icon-star"></i>',
                          shortlist_star_icon,
                      '</span>',
                      image,
                  '</div>',
              '</div>',
            '</div>'].join('');
          } // end for loop

          //add staticBanner at the end
          markup += '<div id="listing-0" class="item item-banner desktop-hidden">' + staticBanner + '</div>';;
        }

        // No project found
        else {
          markup = '<p>No project found.<p>';
          _this.removeMarkers();
        }

        // update map
        _this.updateMapProjects(data);

        //no project message
        if($("#no_project_found").length > 0) {
            $("#no_project_found").remove();
        }
        if(data.not_found) {
            $("#project_list").before("<p id='no_project_found'>Currently no spaces found for your selected floor area. <a href='/contact'>Contact us</a> today to receive a bespoke report for your requirements.<br>Continue to view Projects in selected region.</p>");
        }

        // update DOM
        $("#project_list").html(markup);
        $('[data-toggle="tooltip"]').tooltip();

        // init card sliders
        _this.initItemSlider($("#project_list").find('.item'));



        // hide spinner
        $('.listing-search-section .col-grid').removeClass('loading');
        setTimeout(function(){
          $('.listing-search-section .col-grid .spinner').removeClass('animate');
        }, 400);


        // Update shortlist icons
        shortlist.checkIfProductsShortlisted();
        shortlist.checkIfProjectsShortlisted();
      },
      error: function() {
        _this.removeMarkers();
      }
    });
  },

  // item can be card or popup.
  initItemSlider: function(item) {

    item.each(function(){
      var el = $(this);

      // var container = el.find('.img-wrapper');
      var container = el.find('.listing-item-slider');
      var slider = container.find('.slider');

      if (container === undefined || container.length < 1) return;

      slider.slick({
        infinite: true,
        autoplay:false,
        fade: true,
        speed: 300,
        dots: false,
        arrows: true,
        appendArrows: container,
        prevArrow: '<button type="button" class="slider-prev btn-style-none" alt="Previous Slide">'+arrow_left+'</button>',
        nextArrow: '<button type="button" class="slider-next btn-style-none" alt="Next Slide">'+arrow_right+'</button>',
        draggable: true,
        rows: 0
      });

      slider.on('lazyLoaded', function(event, slick, image, imageSource){
        $(image).parent('.img').css('background-image', 'url("'+imageSource+'")');
      });

    })


  },


  init: function() {

    var _this = this;

    if ($("#search_projects").length < 1 ) { return; }

    // This will let you use the .remove() function later on for popup
    if (!('remove' in Element.prototype)) {
      Element.prototype.remove = function() {
      if (this.parentNode) {
        this.parentNode.removeChild(this);
      }
      };
    }


    if ( window.search_map_projects == undefined ) {
      _this.mapProjects = null;
    } else {
      _this.mapProjects = window.search_map_projects;
    }

    // Init map on Desktop only (no map on tablet)
    if ( !Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)")) {
      _this.initMap();
    }

    $(window).smartresize(function(){
      // Init map on Desktop if not already
      if ( !Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)") && _this.mapInit == false )  {
        _this.initMap();
      }
      // Destroy map on Tablet if not already
      else if ( Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)") && _this.mapInit == true ) {
        _this.destroyMap();
      }
    });

    var card = $('.listing-search-section .listing-grid .item')
    _this.initItemSlider(card);

    // hide spinner and show cards (no ajax call here, simple php on load)
    $('.listing-search-section .col-grid').removeClass('loading');
    setTimeout(function(){
      $('.listing-search-section .col-grid .spinner').removeClass('animate');
    }, 400);


    $(document).on('click', '#search_projects', function () {

      var regions = $("#search_region_options").val();
      var minarea = $("#search_minarea_options").val();
      var maxarea = $("#search_maxarea_options").val();

      // map: unselect active marker
      _this.removePopup();
      _this.removeActiveMarker();

      // update listing
      _this.handleSubmit(regions,minarea,maxarea);
    });


    $(document).on('click', '#reset_projects_search', function () {

      // reset search
      var regions = '';
      var minarea = '';
      var maxarea = '';

      $("#search_region_options").val('');
      $("#search_minarea_options").val('');
      $("#search_maxarea_options").val('');

      $("#search_region_options").selectmenu('refresh');
      $("#search_region_options").parents('.form-group').removeClass('filled');
      $("#search_minarea_options").selectmenu('refresh');
      $("#search_minarea_options").parents('.form-group').removeClass('filled');
      $("#search_maxarea_options").selectmenu('refresh');
      $("#search_maxarea_options").parents('.form-group').removeClass('filled');

      // update listing
      _this.handleSubmit(regions,minarea,maxarea);


      // hide link
      $(this).addClass('is-hidden');

    });

  },

  destroy: function() {
    $(document).off('click', '#search_projects');
    $(document).off('click', '#reset_projects_search');

    this.destroyMap();
  }
}
